import React from 'react';
import PropTypes from 'prop-types';

import { Autocomplete as MUIAutocomplete } from '@mui/material';

// v5 renamed getOptionSelected to isOptionEqualToValue (same signature), and changed
// renderOption's callback signature from (option, state) to (props, option, state) —
// the caller must now render the <li> itself instead of MUI doing it automatically.
// A later version also renamed renderTags to renderValue — the callback keeps the
// same (value, getItemProps) shape, so it's forwarded as-is under the new prop name.
// Adapted here so existing consumers keep using the old, simpler shape.
export const Autocomplete = ({ getOptionSelected, renderOption, renderTags, ...props }) => (
  <MUIAutocomplete
    {...props}
    isOptionEqualToValue={getOptionSelected}
    renderOption={renderOption && ((liProps, option, state) => {
      const { key, ...otherLiProps } = liProps;
      return (
        <li key={key} {...otherLiProps}>
          {renderOption(option, state)}
        </li>
      );
    })}
    renderValue={renderTags}
  />
);

Autocomplete.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  filterOptions: PropTypes.func,
  filterSelectedOptions: PropTypes.bool,
  freeSolo: PropTypes.bool,
  fullWidth: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionSelected: PropTypes.func,
  groupBy: PropTypes.func,
  loading: PropTypes.bool,
  multiple: PropTypes.bool,
  noOptionsText: PropTypes.node,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  open: PropTypes.bool,
  options: PropTypes.array,
  popupIcon: PropTypes.node,
  renderGroup: PropTypes.func,
  renderInput: PropTypes.func.isRequired,
  renderOption: PropTypes.func,
  renderTags: PropTypes.func,
  value: PropTypes.any   // eslint-disable-line react/forbid-prop-types
};

export default Autocomplete;
